function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3253 2H7.675C7.391 2 7.16077 2.26956 7.16077 2.60205V6.21437C7.16077 6.54686 7.391 6.81642 7.675 6.81642H16.3253C16.6093 6.81642 16.8395 6.54686 16.8395 6.21437V2.60205C16.8395 2.26952 16.6093 2 16.3253 2Z",
  fill: "#00A32C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0002 2H7.675C7.391 2 7.16077 2.26956 7.16077 2.60205V6.21437C7.16077 6.54686 7.391 6.81642 7.675 6.81642H12.0002V2Z",
  fill: "#00E03B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1024 3.56638L16.5566 2.06442C16.4296 1.98956 16.2819 1.97953 16.1483 2.03672C16.0148 2.09396 15.9075 2.21337 15.8519 2.36653L12 12.9754L8.1481 2.36653C8.0925 2.21337 7.98516 2.09396 7.8517 2.03672C7.71814 1.97949 7.57038 1.98948 7.44347 2.06442L4.89759 3.56634C4.11256 4.02952 3.78359 5.12569 4.14869 6.06185L7.76397 15.3333H10.6278H16.236L19.8513 6.06189C20.2164 5.12569 19.8875 4.02952 19.1024 3.56638Z",
  fill: "#00E03B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12 12.9754L8.1481 2.36653C8.0925 2.21337 7.98516 2.09396 7.8517 2.03672C7.71814 1.97949 7.57038 1.98948 7.44347 2.06442L4.89759 3.56634C4.11256 4.02952 3.78359 5.12569 4.14869 6.06185L7.76397 15.3333H12V12.9754Z",
  fill: "#82FAA2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0001 12C9.35334 12 7.20007 14.243 7.20007 17C7.20007 19.757 9.35334 22 12.0001 22C14.6468 22 16.8001 19.757 16.8001 17C16.8001 14.243 14.6468 12 12.0001 12Z",
  fill: "#E0B700"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4085 15.2382L12.5862 15.8307C12.6437 16.0223 12.8086 16.1521 12.9946 16.1521H13.5697C13.9857 16.1521 14.1587 16.7287 13.8221 16.9936L13.3569 17.3598C13.2064 17.4782 13.1434 17.6882 13.2009 17.8799L13.3786 18.4724C13.5071 18.9009 13.0543 19.2573 12.7177 18.9925L12.2524 18.6263C12.1019 18.5078 11.8981 18.5078 11.7476 18.6263L11.2823 18.9925C10.9457 19.2573 10.4929 18.901 10.6214 18.4724L10.7991 17.8799C10.8566 17.6882 10.7936 17.4782 10.6431 17.3598L10.1779 16.9936C9.84128 16.7287 10.0143 16.1521 10.4303 16.1521H11.0054C11.1914 16.1521 11.3563 16.0223 11.4138 15.8307L11.5915 15.2382C11.7202 14.8096 12.2799 14.8096 12.4085 15.2382Z",
  fill: "#FFFBE6"
});

var SvgMedal = function SvgMedal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medal.c1a501d2.svg";
export { ForwardRef as ReactComponent };